import { Component } from '@angular/core';

@Component({
  selector: 'app-loading-overlay-full',
  templateUrl: './loading-overlay-full.component.html',
  styleUrls: ['./loading-overlay-full.component.scss']
})
export class LoadingOverlayFullComponent {

}
